import { render, staticRenderFns } from "./Globo.vue?vue&type=template&id=93382c10"
import script from "./Globo.vue?vue&type=script&lang=ts"
export * from "./Globo.vue?vue&type=script&lang=ts"
import style0 from "./Globo.vue?vue&type=style&index=0&id=93382c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports